module.exports = __webpack_public_path__ + "img/tick-inactive.d2f24403.svg";